import {useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {usersColumns} from './columns/_columns'
import {Embedding} from '../core/_models'
import {EmbeddingsListLoading} from '../components/loading/EmbeddingsListLoading'
import {EmbeddingsListPagination} from '../components/pagination/EmbeddingsListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import { useListView } from '../core/ListViewProvider'
import { DeleteWarningModal } from '../user-edit-modal/DisableEnableUser'

const EmbeddingsTable = () => {
  const users = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => users, [users])
  const columns = useMemo(() => usersColumns, [])
  const useListContext= useListView()

  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  function onDisableUser() {

  }


  return (
    <>
    <DeleteWarningModal
        
        action={useListContext.modalAction}
        embedding = {useListContext.user}
        deleteQuery={function (): void {      
          onDisableUser()
        }}
        show={useListContext.statusModal!}
        handleClose={function (): void {
          useListContext.setStatusModal(false,false, {})
        }}/>
    <KTCardBody className='py-4'>
      
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Embedding>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Embedding>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <EmbeddingsListPagination />
      {isLoading && <EmbeddingsListLoading />}
    </KTCardBody>
    </>

  )
}

export {EmbeddingsTable}
